module.exports = __webpack_public_path__ + "static/img/header-newpartner.6d50a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-newpartner.png
// module id = rWLu
// module chunks = 0